import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function ManufacturingModule() {
  return <ModuleNavigation moduleId="ManufacturingModule" />;
}
